var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyGrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.25 15.37c-7.61-2.21-7.61 5.77-2.81 5.66 4.7-.1 5.29 7.51-3.07 5.19M21.26 13.68v.69M21.26 27.27v.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.59 5.39c3.65-1.12 7.79-.24 10.67 2.65 4.16-4.16 10.9-4.16 15.07 0 4.16 4.16 4.16 10.9 0 15.07L21.26 38.18 6.19 23.11c-3.08-3.08-3.88-7.59-2.4-11.41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 6.69,
    cy: 7.91,
    r: 1.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyGrant);
export default __webpack_public_path__ + "static/media/applyGrant.d99ff317b560475a40ab737d74859d90.svg";
export { ForwardRef as ReactComponent };